export const CONSTANT = {
  QUANTITY: 'QUANTITY',
  DUPLICATION: 'DUPLICATION',
} as const;

export interface AddProductOptionSetReturnType {
  is_success: boolean;
  type?: typeof CONSTANT.DUPLICATION | typeof CONSTANT.QUANTITY;
}
